import { Icon } from '../ds';
import { icons } from '../icons';
import { c, cardStyle, eyebrowStyle, h1Style, ledeStyle, pageStyle } from '../tokens';

const FEEDBACK_FORM_URL = 'https://forms.gle/BJ57siZJ3jWWkbwR8';

export function Feedback() {
  return (
    <div style={{ ...pageStyle, gap: 28 }}>
      <header style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <span style={eyebrowStyle}>Feedback</span>
        <h1 style={h1Style}>Help us improve the platform</h1>
        <p style={ledeStyle}>
          Your experience matters. We welcome feedback about what is working, what feels unclear, and
          what would make it easier to build and operate your apps.
        </p>
      </header>

      <section
        style={{
          ...cardStyle,
          maxWidth: 720,
          padding: 32,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 18,
        }}
      >
        <div
          style={{
            width: 42,
            height: 42,
            borderRadius: 12,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: c.brand,
            background: '#FFF0EC',
          }}
        >
          <Icon name={icons.feedback} size="md" color="currentColor" />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <h2 style={{ margin: 0, fontSize: 20, lineHeight: 1.35, fontWeight: 475 }}>
            We would love to hear from you
          </h2>
          <p style={{ margin: 0, color: c.textBody, fontSize: 14.5, lineHeight: 1.6 }}>
            Share an idea, report a rough edge, or tell us what you would like the Citizen Developer
            Platform to support next. The form opens in a new tab.
          </p>
        </div>
        <a
          href={FEEDBACK_FORM_URL}
          target="_blank"
          rel="noreferrer"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            padding: '10px 16px',
            borderRadius: 10,
            background: c.brand,
            color: '#fff',
            fontSize: 14,
            fontWeight: 475,
            textDecoration: 'none',
          }}
        >
          Open feedback form
          <Icon name={icons.openInNew} size="sm" color="currentColor" />
        </a>
      </section>
    </div>
  );
}
